import api from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoLinkTag.js";
            import content from "!!../../../node_modules/file-loader/dist/cjs.js??ref--8-oneOf-3-1!../../../node_modules/extract-loader/lib/extractLoader.js!../../../node_modules/css-loader/dist/cjs.js??ref--8-oneOf-3-3!../../../node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-3-4!../../../loaders/scss-merger-loader/index.js??ref--8-oneOf-3-5!./vitalliance.theme.scss";

var options = {"injectType":"linkTag","attributes":{"data-pro-account-theme":true}};

options.insert = "head";

var update = api(content, options);



export default {}